import type { IPropsGetCheckRegister } from '../../API/checkRegister'
import type { LineCheck } from '../../interfaces'

import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import CheckRegister from '../../API/checkRegister'
export interface IGridSlice {
  data: LineCheck[]
  isLoadedCheck: boolean
  count: string
}

export const fetchCheckRegister = createAsyncThunk(
  'table/fetchRegister',
  async (params: IPropsGetCheckRegister) => {
    const response = await CheckRegister.getCheckRegister(params)
    return response
  }
)

const initialState: IGridSlice = {
  data: [],
  isLoadedCheck: false,
  count: '2000'
}

export const checkRegisterSlice = createSlice({
  name: 'grid',
  initialState,
  reducers: {
    clearCheckData: state => {
      state.data = []
    }
  },
  extraReducers: builder => {
    builder.addCase(fetchCheckRegister.fulfilled, (state, action) => {
      state.data = action.payload.data.rows
      state.count = action.payload.data.count
      state.isLoadedCheck = false
    })
    builder.addCase(fetchCheckRegister.pending, (state, _action) => {
      state.isLoadedCheck = true
    })
  }
})
export const { clearCheckData } = checkRegisterSlice.actions
export default checkRegisterSlice.reducer
